<template>
  <v-container class="bg-white">
    <v-card
      class="pa-5"
      variant="text">
      <v-card-title>Eigene Lizenz bearbeiten</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="6"> Zahlungsart </v-col>
          <v-col cols="6"> Visa </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
      </v-card-actions>
    </v-card>
    <v-divider></v-divider>
    <ModuleListPrivate
      v-if="loaded"
      :model-value="modules"
      :slots="modules"
      :allSlots="allModules"
      :save="updateModules" />
  </v-container>
</template>

<script lang="ts" setup>
import { useSpaceStore } from "@/stores/spaceStore";
import axios from "axios";
import { useTranslation } from "i18next-vue";
import { onMounted } from "vue";
import { computed } from "vue";
import { ref } from "vue";
import { useConfirm, useSnackbar } from "vuetify-use-dialog";
import { SPACE_RIGHT_WRITE, spaceRightNames } from "@/utils/constants";
import { useMainStore } from "@/stores/mainStore";
import { useAuthStore } from "@/stores/authStore";
import { SPACE_RIGHT_READ, MODULES } from "@/utils/constants";
import ModuleListPrivate from "./Licence/ModuleListPrivate.vue";
import { useRouter } from "vue-router";

const mainStore = useMainStore();
const router = useRouter();

const { t } = useTranslation();
const createConfirm = useConfirm();
const createSnackbar = useSnackbar();

const emits = defineEmits(["close"]);

const modules = ref({});
const allModules = ref({});

const loaded = ref(false);

onMounted(() => {
  axios.get("/api/licence/private").then((response) => {
    console.log(response.data);

    modules.value = formatModules(response?.data?.modules);
    allModules.value = formatModules(response?.data?.modules);
    loaded.value = true;
  });
});

function formatModules(
  modules: Record<string, number>
): Record<number, number> {
  return Object.fromEntries(
    mainStore.modules.map((module) => [module.value, modules[module.name]])
  );
}

const byName = computed(() => {
  return Object.fromEntries(
    mainStore.modules.map((module) => [
      module.name,
      modules.value[module.value]
    ])
  );
});

function updateModules() {
  axios.post("/api/licence/private", { modules: byName.value }).then(() => {
    mainStore.loadCalculationSpaces();
    router.back();
  });
}
</script>
